module.exports = {"220211001":"泰山街道","220211002":"江南街道","220211003":"石井街道","220211004":"沿丰街道","220211005":"丰满街道","220211071":"红旗街道","220211100":"旺起镇","220211200":"江南乡","220211201":"前二道乡","220211270":"小白山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220211.json
// module id = 620
// module chunks = 0